export const WORDS = [
  { word: "tunnag", ipa: "/ˈtʰun̪ˠak/" },
  { word: "snog", ipa: "/sn̪ˠok/" },
  { word: "seo", ipa: "/ʃɔ/" },
  { word: "piseag", ipa: "/ˈpʰiʃak/" },
  { word: "muc", ipa: "/muxk/" },
  { word: "Mòrag", ipa: "/ˈmoːɾak/" },
  { word: "mòr", ipa: "/ˈmoːɾ/" },
  { word: "math", ipa: "/maː/" },
  { word: "Irn bru", ipa: "no ipa found" },
  { word: "Iain", ipa: "/iaɲ/" },
  { word: "gàidhlig", ipa: "/gaːlɪgʲ/" },
  { word: "Eilidh", ipa: "/elɪ/" },
  { word: "dona", ipa: "/ˈt̪ɔnə/" },
  { word: "cù", ipa: "/kʰuː/" },
  { word: "cearc", ipa: "/kʲʰɛɾxk/" },
  { word: "cat", ipa: "/kʰaʰt̪/" },
  { word: "caraid", ipa: "/kʰaɾɪtʲ/" },
  { word: "Calum", ipa: "/ˈkʰal̪ˠəm/" },
  { word: "caileag", ipa: "/ˈkʰalak/" },
  { word: "bò", ipa: "/poː/" },
  { word: "beag", ipa: "/pek/" },
  { word: "balach", ipa: "/ˈpal̪ˠəx/" },
  { word: "Anna", ipa: "/ˈan̪ˠa/" },
  { word: "agus", ipa: "/ˈakəs/" },
  { word: "uisge-beatha", ipa: "/ˈɯʃkʲəˈpɛhə/" },
  { word: "uisge", ipa: "/ˈɯʃkʲə/" },
  { word: "taigeis", ipa: "/h/" },
  { word: "sin", ipa: "[ʃɪn]" },
  { word: "sgadan", ipa: "/ˈs̪kat̪an/" },
  { word: "seo", ipa: "/ʃɔ/" },
  { word: "salann", ipa: "/ˈs̪al̪ˠən̪ˠ/" },
  { word: "rìs", ipa: "/rˠiːʃ/" },
  { word: "piobar", ipa: "/pibər/" },
  { word: "is toil leam", ipa: "no ipa found" },
  { word: "ìm", ipa: "[iːm]" },
  { word: "idir", ipa: "/ˈitʲɪɾʲ/" },
  { word: "iasg", ipa: "/iəsk/" },
  { word: "hama", ipa: "/ˈhamə/" },
  { word: "guga", ipa: "/ˈkukə/" },
  { word: "cha toil leam", ipa: "no ipa found" },
  { word: "cèic", ipa: "/kʲeːçgʲ/" },
  { word: "càise", ipa: "/ˈkʰaːʃə/" },
  { word: "buntàta", ipa: "/pən̪ˠˈt̪ʰaːht̪ə/" },
  { word: "brot", ipa: "/pɾɔht̪/" },
  { word: "brochan", ipa: "/ˈpɾɔxan/" },
  { word: "blasta", ipa: "/ˈpl̪ˠas̪t̪ə/" },
  { word: "biadh", ipa: "/piəɣ/" },
  { word: "aran", ipa: "[aɾan]" },
  { word: "tìoraidh", ipa: "/tʲiːrɪ/" },
  { word: "tì", ipa: "/t̪ʰiː/" },
  { word: "tapadh leibh", ipa: "no ipa found" },
  { word: "tapadh leat", ipa: "no ipa found" },
  { word: "slàinte", ipa: "/ˈslaːnt͡ʃə/" },
  { word: "siùcar", ipa: "/ˈʃuːxkər/" },
  { word: "sgoinneil", ipa: "/ˈs̪kɤɲal/" },
  { word: "ollaimh", ipa: "/ˈɔl̪ˠɪv/" },
  { word: "oidhche mhath", ipa: "/ˌɤɪçə ˈvaː/" },
  { word: "oidhche", ipa: "/ˈɤ̃ĩçə/" },
  { word: "madainn mhath", ipa: "/madən va/" },
  { word: "leat", ipa: "/lɛʰt̪/" },
  { word: "Iseabail", ipa: "/iʃəbal/" },
  { word: "halò", ipa: "/haˈloː/" },
  { word: "feasgar math", ipa: "no ipa found" },
  { word: "fàilte", ipa: "/ˈfaːltʲə/" },
  { word: "Eilidh", ipa: "/elɪ/" },
  { word: "Ealasaid", ipa: "/ˈɛl̪ˠəs̪ɪtʲ/" },
  { word: "cofaidh", ipa: "/ˈkʰɔfi/" },
  { word: "ceud mìle fàilte", ipa: "/kʲiəd miːlə faːldʲə/" },
  { word: "bainne", ipa: "/ˈpaɲɪ/" },
  { word: "athair", ipa: "/ˈahəɾʲ/" },
  { word: "Anndra", ipa: "/ˈãũn̪ˠt̪ɾə/" },
  { word: "Anna", ipa: "/ˈan̪ˠa/" },
  { word: "a thidseir", ipa: "no ipa found" },
  { word: "a sheanair", ipa: "/ˈhɛnɪɾʲ/" },
  { word: "a phiuthar", ipa: "/fju.əɾ/" },
  { word: "a mhàthair", ipa: "/ˈvaːhəɾʲ/" },
  { word: "a charaid", ipa: "/karɪdʲ/" },
  { word: "a bhràthair", ipa: "/braːhɪrʲ/" },
  { word: "a bhalaich", ipa: "/ˈval̪ˠɪç/" },
  { word: "toilichte", ipa: "/ˈtʰɔləçtʲə/" },
  { word: "thu", ipa: "/(h)u/" },
  { word: "spòrsail", ipa: "/ˈspɔːrsal/" },
  { word: "sibh", ipa: "/ˈʃiv/" },
  { word: "sgìth", ipa: "/s̪kʲiː/" },
  { word: "Seumas", ipa: "/ʃeːməs̪/" },
  { word: "mi", ipa: "/ˈmi/" },
  { word: "iseabail", ipa: "/iʃəbal/" },
  { word: "i", ipa: "/ˈi/" },
  { word: "gu math", ipa: "no ipa found" },
  { word: "gabh mo leisgeul", ipa: "/kav mə ˈʎeʃkʲəl̪ˠ/" },
  { word: "e", ipa: "/ˈɛ/" },
  { word: "duilich", ipa: "/ˈtɯlʲɪç/" },
  { word: "crosta", ipa: "/ˈkʰɾɔs̪t̪ə/" },
  { word: "ciamar a tha", ipa: "no ipa found" },
  { word: "cho", ipa: "/xɔ/" },
  { word: "ceart gu leòr", ipa: "/kʲʰarˠʃt kə ʎɔːɾ/" },
  { word: "brònach", ipa: "/ˈpɾɔːnəx/" },
  { word: "Anndra", ipa: "/ˈãũn̪ˠt̪ɾə/" },
  { word: "a-nis", ipa: "/ə ˈniʃ/" },
  { word: "air bhioran", ipa: "no ipa found" },
  { word: "trang", ipa: "/tʰɾaŋk/" },
  { word: "steòrnabhagh", ipa: "/ʃdʲɔːRNəvaɣ/" },
  { word: "Seòras", ipa: "/ˈʃɔːɾˠəs/" },
  { word: "sasainn", ipa: "/sasɪNʲ/" },
  { word: "muile", ipa: "/mulə/" },
  { word: "mòr", ipa: "/ˈmoːɾ/" },
  { word: "Màiri", ipa: "/ˈmaːɾʲi/" },
  { word: "lunnainn", ipa: "/LuNɪNʲ/" },
  { word: "leòdhas", ipa: "/Lʲɔː.əs/" },
  { word: "inbhir nis", ipa: "/iNʲɪrʲˈniʃ/" },
  { word: "ìle", ipa: "/iːlə/" },
  { word: "Iain", ipa: "/iaɲ/" },
  { word: "glaschu", ipa: "/gLasəxu/" },
  { word: "èirinn", ipa: "/eːrʲɪNʲ/" },
  { word: "dùn èideann", ipa: "/dunˈeːdʲəN/" },
  { word: "dùn", ipa: "/t̪uːn/" },
  { word: "cò", ipa: "[kʰoː]" },
  { word: "canada", ipa: "/kanadə/" },
  { word: "barraigh", ipa: "/baRaj/" },
  { word: "alba nuadh", ipa: "no ipa found" },
  { word: "alba", ipa: "/aLabə/" },
  { word: "àlainn", ipa: "/aːɫ̪ɪɲ/" },
  { word: "aimearaga", ipa: "no ipa found" },
  { word: "orm", ipa: "/ˈɔɾəm/" },
  { word: "lèine", ipa: "/ˈʎeːɲə/" },
  { word: "lèine-t", ipa: "no ipa found" },
  { word: "sgiort", ipa: "/s̪cɤɾˠʃt̪/" },
  { word: "bròg", ipa: "/pɾɔːk/" },
  { word: "seall", ipa: "/ʃaul̪ˠ/" },
  { word: "briogais", ipa: "/ˈpɾʲikɪʃ/" },
  { word: "bòtannan", ipa: "/bɔːhdəN/" },
  { word: "còta", ipa: "[ˈkʰɔːʰt̪ə]" },
  { word: "ort", ipa: "/ɔrˠs̪t/" },
  { word: "bonaid", ipa: "/ˈpɔnatʲ/" },
  { word: "drathais", ipa: "/ˈt̪ɾa.ɪʃ/" },
  { word: "ag iarraidh", ipa: "no ipa found" },
  { word: "a' ceannach", ipa: "/ˈcʰan̪ˠəx/" },
  { word: "dreasa", ipa: "/ˈt̪ɾes̪ə/" },
  { word: "speuclairean", ipa: "/ˈs̪piaxkl̪ˠɪɾʲən/" },
  { word: "geansaidh", ipa: "/ˈkʲɛns̪ɪ/" },
  { word: "uaireadair", ipa: "/uərʲədɪrʲ/" },
  { word: "sinn", ipa: "/ˈʃiɲ/" },
  { word: "iad", ipa: "/ˈiə̯t̪/" },
  { word: "stocainnean", ipa: "/sdɔxgɪNʲ/" },
  { word: "fèileadh", ipa: "/feːləɣ/" },
  { word: "aodach", ipa: "/ˈɯːt̪əx/" },
  { word: "seacaid", ipa: "/ˈʃɛxkatʲ/" },
  { word: "agam", ipa: "/ˈakəm/" },
  { word: "luch", ipa: "/ɫ̪ux/" },
  { word: "eun", ipa: "/ian/" },
  { word: "cuilean", ipa: "/ˈkʰulan/" },
  { word: "brèagha", ipa: "/ˈpɾʲi.ə/" },
  { word: "peata", ipa: "/pɛhdə/" },
  { word: "agad", ipa: "/ˈakət̪/" },
  { word: "uan", ipa: "/uan/" },
  { word: "each", ipa: "/ɛx/" },
  { word: "caora", ipa: "[kʰɯːɾə]" },
  { word: "glè mhath", ipa: "no ipa found" },
  { word: "glè bheag", ipa: "no ipa found" },
  { word: "glè", ipa: "/kleː/" },
  { word: "losgann", ipa: "/ˈl̪ˠɔs̪kən̪ˠ/" },
  { word: "àrd", ipa: "/ˈaːrˠt̪/" },
  { word: "òg", ipa: "[ɔːɡ̊]" },
  { word: "èibhinn", ipa: "/ˈeːvɪɲ/" },
  { word: "gòrach", ipa: "/ˈkɔːɾəx/" },
  { word: "a' faicinn", ipa: "/ˈfɛçcɪɲ/" },
  { word: "a' cluinntinn", ipa: "/ˈkʰl̪ˠɯ̃ĩɲtʲɪɲ/" },
  { word: "damhan-allaidh", ipa: "/t̪ˠavanˈal̪ˠɪ/" },
  { word: "radan", ipa: "/ˈra.tən/" },
  { word: "coineanach", ipa: "/ˈkʰɔɲanəx/" },
  { word: "gobhar", ipa: "/ko.əɾ/" },
  { word: "fliuch", ipa: "/flux/" },
  { word: "fuar", ipa: "/fuəɾ/" },
  { word: "gaothach", ipa: "/ˈkɯː.əx/" },
  { word: "blàth", ipa: "/pl̪ˠaː/" },
  { word: "grianach", ipa: "/ˈcɾʲianəx/" },
  { word: "ceòthach", ipa: "/kʲɔː.əx/" },
  { word: "garbh", ipa: "/ˈkaɾav/" },
  { word: "bheil", ipa: "/vel̪/" },
  { word: "a-muigh", ipa: "/əˈmuj/" },
  { word: "a' faireachdainn", ipa: "/ˈfaɾəxkɪɲ/" },
  { word: "sgòthach", ipa: "/ˈs̪kɔː.əx/" },
  { word: "gu math", ipa: "no ipa found" },
  { word: "dorcha", ipa: "/ˈt̪ɔɾɔxə/" },
  { word: "cuidich mi", ipa: "no ipa found" },
  { word: "slàinte mhath", ipa: "no ipa found" },
  { word: "dè tha dol", ipa: "no ipa found" },
  { word: "a chàirdean", ipa: "/ˈxaːrˠtʲən/" },
  { word: "tìoraidh an-dràsta", ipa: "no ipa found" },
  { word: "dè", ipa: "/tʲeː/" },
  { word: "a-rithist", ipa: "/əˈɾʲi.ɪʃtʲ/" },
  { word: "mòran taing", ipa: "no ipa found" },
  { word: "s e do bheatha", ipa: "/ʃɛ də vɛhə/" },
  { word: "feumaidh mi falbh", ipa: "no ipa found" },
  { word: "na gabh dragh", ipa: "no ipa found" },
  { word: "a' tuigsinn", ipa: "/ˈt̪ʰɯcʃɪɲ/" },
  { word: "bruidhinn nas slaodaiche", ipa: "no ipa found" },
  { word: "can sin a-rithist", ipa: "no ipa found" },
  { word: "mar sin leat", ipa: "no ipa found" },
  { word: "beatha", ipa: "/ˈpɛhə/" },
  { word: "dè an t-ainm a th' ort", ipa: "no ipa found" },
  { word: "cailean", ipa: "/kalan/" },
  { word: "beathag", ipa: "/bɛhag/" },
  { word: "raonaid", ipa: "/Rɤːnɪdʲ/" },
  { word: "ainm", ipa: "/ˈɛnɛm/" },
  { word: "Dòmhnall", ipa: "/ˈt̪oːnaɫ/" },
  { word: "cuideachd", ipa: "/ˈkʰutʲəxk/" },
  { word: "obh obh", ipa: "/oːvoːv/" },
  { word: "runrig", ipa: "no ipa found" },
  { word: "an t-uisge", ipa: "no ipa found" },
  { word: "sneachd", ipa: "/ʃɲɛxk/" },
  { word: "reòthadh", ipa: "/ˈrˠɔː.əɣ/" },
  { word: "ach", ipa: "/aːχ/" },
  { word: "dealanaich", ipa: "/ˈtʲal̪ˠanəxʲ/" },
  { word: "tàirneanaich", ipa: "/taːRNʲənəx/" },
  { word: "fhathast", ipa: "/ˈha.əs̪t̪/" },
  { word: "no", ipa: "/ˈnɔ/" },
  { word: "an-dràsta", ipa: "/ən̪ˠˈt̪ɾaːs̪t̪ə/" },
  { word: "an-diugh", ipa: "/əɲˈtʲu/" },
  { word: "cò ris a tha an t-sìde coltach", ipa: "no ipa found" },
  { word: "aon chù", ipa: "no ipa found" },
  { word: "bàta", ipa: "/paːʰt̪ə/" },
  { word: "aon bhàta", ipa: "no ipa found" },
  { word: "aon chàr", ipa: "no ipa found" },
  { word: "bus", ipa: "/pus̪/" },
  { word: "aon bhus", ipa: "no ipa found" },
  { word: "càr", ipa: "/kʰaːɾ/" },
  { word: "aon", ipa: "/ɯːn/" },
  { word: "cia mheud", ipa: "/kʲaˈviəd/" },
  { word: "asal", ipa: "/ˈʔasal/" },
  { word: "eala", ipa: "/ˈjal̪ˠə/" },
  { word: "uinneag", ipa: "/ɯNʲag/" },
  { word: "dà", ipa: "/taː/" },
  { word: "òran", ipa: "/ˈɔːran/" },
  { word: "dà chàr", ipa: "no ipa found" },
  { word: "dà bhus", ipa: "no ipa found" },
  { word: "dà mhuc", ipa: "no ipa found" },
  { word: "dà phiseag", ipa: "no ipa found" },
  { word: "dà chù", ipa: "no ipa found" },
  { word: "dà chat", ipa: "no ipa found" },
  { word: "bràthair", ipa: "/braːhɪrʲ/" },
  { word: "aon bhràthair", ipa: "no ipa found" },
  { word: "bràithrean", ipa: "/braːhɪrʲ/" },
  { word: "piuthar", ipa: "/h/" },
  { word: "aon phiuthar", ipa: "no ipa found" },
  { word: "seanair", ipa: "/ˈʃɛnɪɾʲ/" },
  { word: "athair", ipa: "/ˈahəɾʲ/" },
  { word: "mac", ipa: "/maʰk/" },
  { word: "teaghlach", ipa: "/ˈtʃʰɤːɫ̪əx/" },
  { word: "leanabh", ipa: "/ˈʎɛnəv/" },
  { word: "peathraichean", ipa: "/pju.ər/" },
  { word: "bean", ipa: "[b̥ɛn]" },
  { word: "seanmhair", ipa: "/ˈʃɛ.nə.vɛɾʲ/" },
  { word: "nighean", ipa: "/ɲiː.an̪ˠ/" },
  { word: "màthair", ipa: "/ˈmaːhəɾʲ/" },
  { word: "ainmeil", ipa: "/ɛnɛmal/" },
  { word: "antaidh", ipa: "no ipa found" },
  { word: "uncail", ipa: "/uŋgal/" },
  { word: "an duine agam", ipa: "no ipa found" },
  { word: "againn", ipa: "/ˈakɪɲ/" },
  { word: "clann", ipa: "/kʰl̪ˠaun̪ˠ/" },
  { word: "luath", ipa: "/l̪ˠuə/" },
  { word: "reamhar", ipa: "/ˈrˠãũ.əɾ/" },
  { word: "onarach", ipa: "/ˈɔnaɾəx/" },
  { word: "sgriosail", ipa: "/ˈs̪kɾʲis̪al/" },
  { word: "laghach", ipa: "/ˈl̪ˠɤ.əx/" },
  { word: "neònach", ipa: "/ˈɲɔːnəx/" },
  { word: "leabhar", ipa: "/ˈʎo.əɾ/" },
  { word: "rathad", ipa: "/rˠahad/" },
  { word: "sgian", ipa: "/s̪kʲian/" },
  { word: "sgillinn", ipa: "/ˈskʲiʎɪɲ/" },
  { word: "stais", ipa: "/st̪aʃ/" },
  { word: "latha", ipa: "/l̪ˠa.a/" },
  { word: "smiogaid", ipa: "/ˈs̪mikatʲ/" },
  { word: "not", ipa: "/n̪ˠɔht̪/" },
  { word: "trì", ipa: "/tʲʰɾʲiː/" },
  { word: "ceithir", ipa: "/kʲehɪrʲ/" },
  { word: "còig", ipa: "[koːɡ̊ʲ]" },
  { word: "sia", ipa: "/ʃia/" },
  { word: "bàtaichean", ipa: "/baːhdə/" },
  { word: "mucan", ipa: "/muʰkən/" },
  { word: "piseagan", ipa: "/piʃag/" },
  { word: "seachd", ipa: "/ʃɛxk/" },
  { word: "ochd", ipa: "/ɔxk/" },
  { word: "naoi", ipa: "/nɯːi/" },
  { word: "deich", ipa: "/tʲeç/" },
  { word: "coin", ipa: "/kɔːNʲ/" },
  { word: "cait", ipa: "/kʰɛʰtʲ/" },
  { word: "a' faighinn", ipa: "/ˈfajɪɲ/" },
  { word: "sùgh", ipa: "/s̪uː/" },
  { word: "leann", ipa: "/ʎaun̪ˠ/" },
  { word: "sùbh-làir", ipa: "/ˌs̪uːˈl̪ˠaːɾʲ/" },
  { word: "uachdar", ipa: "/uəxgər/" },
  { word: "suiteas", ipa: "no ipa found" },
  { word: "fìon", ipa: "/fiən/" },
  { word: "mions", ipa: "/mins/" },
  { word: "botal", ipa: "/ˈpɔhtəl̪ˠ/" },
  { word: "brot", ipa: "/pɾɔht̪/" },
  { word: "paidh", ipa: "/paːj/" },
  { word: "ubhal", ipa: "/ˈu.əɫ̪/" },
  { word: "orainsear", ipa: "/ˈɔɾɪɲʃɛɾ/" },
  { word: "isbean", ipa: "/iʃban/" },
  { word: "aran", ipa: "[aɾan]" },
  { word: "ìm", ipa: "[iːm]" },
  { word: "bu toil leam", ipa: "no ipa found" },
  { word: "ag ithe", ipa: "no ipa found" },
  { word: "snèap", ipa: "/ʃɲɛːhp/" },
  { word: "reòiteag", ipa: "[rʲot͡ʃʲak]" },
  { word: "biadh", ipa: "/piəɣ/" },
  { word: "ugh", ipa: "/u/" },
  { word: "ag òl", ipa: "/ha ə fiʃag ə gɔːL nə greːNʲə/" },
  { word: "cha bu toil leam", ipa: "no ipa found" },
  { word: "glè bhlasta", ipa: "no ipa found" },
  { word: "tomàto", ipa: "/tɔˈmaːtɔ/" },
  { word: "uinnean", ipa: "/ˈɯɲan/" },
  { word: "curran", ipa: "/ˈkʰurˠan/" },
  { word: "òl", ipa: "[ɔːɫ̪ ]" },
  { word: "aig", ipa: "/ɛkʲ/" },
  { word: "geal", ipa: "/kʲaɫ̪/" },
  { word: "dubh", ipa: "/t̪uh/" },
  { word: "orains", ipa: "/ɔrɪnʃ/" },
  { word: "purpaidh", ipa: "/ˈpʰurpi/" },
  { word: "ùr", ipa: "[uːɾ]" },
  { word: "e", ipa: "/ˈɛ/" },
  { word: "pinc", ipa: "/pʰiŋʲkʲ/" },
  { word: "dearg", ipa: "/ˈtʲɛɾɛk/" },
  { word: "gorm", ipa: "/ˈkɔrɔ̃m/" },
  { word: "feumaidh mi", ipa: "no ipa found" },
  { word: "feumaidh tu", ipa: "no ipa found" },
  { word: "buidhe", ipa: "/ˈpujə/" },
  { word: "glas", ipa: "/kl̪ˠas̪/" },
  { word: "uaine", ipa: "/ˈuəɲə/" },
  { word: "donn", ipa: "/t̪ɔun̪ˠ/" },
  { word: "liath", ipa: "/ʎiə/" },
  { word: "briogais ghoirid", ipa: "no ipa found" },
  { word: "putan", ipa: "/ˈpʰuht̪an/" },
  { word: "goirid", ipa: "/ˈkɤɾʲɪtʲ/" },
  { word: "gu leòr", ipa: "/kəˈʎɔːɾ/" },
  { word: "fada", ipa: "/ˈfat̪ə/" },
  { word: "a' dèanamh", ipa: "/ˈtʲianəv/" },
  { word: "crios", ipa: "/kʰɾʲis̪/" },
  { word: "a' goid", ipa: "/kɤtʲ/" },
  { word: "a' cumail", ipa: "/kumal/" },
  { word: "deise", ipa: "/ˈtʲeʃə/" },
  { word: "eile", ipa: "/ˈelə/" },
  { word: "taigh", ipa: "/tʰɤj/" },
  { word: "gàrradh", ipa: "/ˈkaːrˠəɣ/" },
  { word: "coimpiutair", ipa: "/kʰəmˈpʰjutʰəɾʲ/" },
  { word: "an toil leat", ipa: "no ipa found" },
  { word: "deasg", ipa: "/tʲɛs̪k/" },
  { word: "iuchair", ipa: "/ˈjuxɪɾʲ/" },
  { word: "flat", ipa: "/fLahd/" },
  { word: "bòrd", ipa: "[b̊ɔːɹʃd̪̊]" },
  { word: "preas", ipa: "/ˈpɾeas/" },
  { word: "mapa", ipa: "/ˈmahpə/" },
  { word: "dealbh", ipa: "[ˈtʲaɫ̪av]" },
  { word: "soitheach", ipa: "/sɤ.əx/" },
  { word: "amar", ipa: "/aˈmaɾ/" },
  { word: "eadar-lìon", ipa: "/ˈet̪əɾʎʲiən/" },
  { word: "òrd", ipa: "[ɔːɹʃd̪̊]" },
  { word: "aca", ipa: "/ˈaʰkə/" },
  { word: "seòmar-cadail", ipa: "no ipa found" },
  { word: "sin", ipa: "[ʃɪn]" },
  { word: "aige", ipa: "/ˈɛkʲə/" },
  { word: "taigh-beag", ipa: "/təˈbeg/" },
  { word: "frids", ipa: "/fɾʲitʲʃ/" },
  { word: "balla", ipa: "/ˈpaɫ̪ə/" },
  { word: "seo", ipa: "/ʃɔ/" },
  { word: "càit a bheil", ipa: "no ipa found" },
  { word: "an toil leibh", ipa: "no ipa found" },
  { word: "leabaidh", ipa: "/ˈʎepɪ/" },
  { word: "teine", ipa: "/ˈt͡ʃʰenə/" },
  { word: "doras", ipa: "/ˈt̪ɔ.ɾəs̪/" },
  { word: "aice", ipa: "/ˈɛʰkʲə/" },
  { word: "ann an", ipa: "/ˈan̪ˠən̪ˠ/" },
  { word: "ag obair", ipa: "no ipa found" },
  { word: "dùn dè", ipa: "/dunˈdʲeː/" },
  { word: "Sruighlea", ipa: "/ˈs̪t̪ɾuilə/" },
  { word: "Sealtainn", ipa: "/ˈʃɛl̪ˠt̪ɪɲ/" },
  { word: "sgoil", ipa: "/sgɔl/" },
  { word: "obair", ipa: "/opəɾʲ/" },
  { word: "a' fuireach", ipa: "/ˈfuɾʲəx/" },
  { word: "Obar dheathain", ipa: "/obərˈɛ.ɛNʲ/" },
  { word: "Arcaibh", ipa: "/ˈaɾxkɪv/" },
  { word: "glè mhòr", ipa: "no ipa found" },
  { word: "ospadal", ipa: "/ɔsbədəL/" },
  { word: "oilthigh", ipa: "/ˈɤlhɪ/" },
  { word: "Inbhir àir", ipa: "no ipa found" },
  { word: "Peairt", ipa: "/pʰɛrˠʃtʲ/" },
  { word: "Port rìgh", ipa: "/pɔRʃdˈriː/" },
  { word: "muga", ipa: "/ˈmukə/" },
  { word: "baile", ipa: "/ˈpalɪ/" },
  { word: "Fìobha", ipa: "/ˈfiːvə/" },
  { word: "Astràilia", ipa: "/asdraːliə/" },
  { word: "Afraga a deas", ipa: "no ipa found" },
  { word: "Nirribhidh", ipa: "/ɲir̪ˠɪvi/" },
  { word: "an seo", ipa: "/əˈʃɔ/" },
  { word: "an sin", ipa: "/ə(ɲ)ˈʃin/" },
  { word: "Sealainn nuadh", ipa: "/ʃaLɪNʲ nuəɣ/" },
  { word: "Iapan", ipa: "no ipa found" },
  { word: "aice", ipa: "/ˈɛʰkʲə/" },
  { word: "Uibhist", ipa: "/ˈɯ.ɪʃtʲ/" },
  { word: "bùth", ipa: "/puː/" },
  { word: "oifis", ipa: "/ˈɔfɪʃ/" },
  { word: "margadh", ipa: "/ˈmaɾˠakəɣ/" },
  { word: "taigh-òsta", ipa: "/t̪ʰəˈɔːs̪t̪ə/" },
  { word: "Tiriodh", ipa: "/ˈt͡ʃʰiɾʲəɣ/" },
  { word: "meal do naidheachd", ipa: "no ipa found" },
  { word: "deoch", ipa: "/tʲɔx/" },
  { word: "ist", ipa: "/ɪʃtʲ/" },
  { word: "tha gàidhlig agam", ipa: "no ipa found" },
  { word: "a bheil gàidhlig agad", ipa: "no ipa found" },
  { word: "tha beagan gàidhlig agam", ipa: "no ipa found" },
  { word: "tha fios agam", ipa: "no ipa found" },
  { word: "chan eil fios agam", ipa: "no ipa found" },
  { word: "sibh", ipa: "/ˈʃiv/" },
  { word: "chì mi a-rithist thu", ipa: "no ipa found" },
  {
    word: "a h-uile duine",
    ipa: "/ə xulə dɯNʲə/",
  },
  { word: "thig a-steach", ipa: "no ipa found" },
  { word: "m' eudail", ipa: "no ipa found" },
  { word: "chì", ipa: "[t͡ɕi˨˩]" },
  { word: "agaibh", ipa: "/ˈakɪv/" },
  { word: "mealaibh ur naidheachd", ipa: "no ipa found" },
  { word: "eairdsidh", ipa: "/ɛːRdʲɪ/" },
  { word: "oighrig", ipa: "/ɤirʲɪgʲ/" },
  { word: "a' bruidhinn", ipa: "/ˈpɾi.ɪɲ/" },
  { word: "ag ionnsachadh", ipa: "no ipa found" },
  { word: "falt", ipa: "/fal̪ˠt̪/" },
  { word: "beul", ipa: "/piaɫ̪/" },
  { word: "broilleach", ipa: "/ˈpɾɔʎəx/" },
  { word: "maol", ipa: "/mɯːɫ̪/" },
  { word: "grànda", ipa: "/ˈkɾãːn̪ˠtə/" },
  { word: "ceann", ipa: "/kʲʰaun/" },
  { word: "aodann", ipa: "/ˈɯːt̪ən̪ˠ/" },
  { word: "tinn", ipa: "/t͡ʃʰĩːɲ/" },
  { word: "goirt", ipa: "/kɔrt͡ʃʲ/" },
  { word: "fallain", ipa: "/ˈfal̪ˠəɲ/" },
  { word: "làmh", ipa: "[ɫ̪ãːv]" },
  { word: "cluas", ipa: "/kLuəs/" },
  { word: "sùil", ipa: "/s̪uːl/" },
  { word: "sròn", ipa: "/s̪t̪ɾɔːn/" },
  { word: "duine", ipa: "/t̪ɯɲə/" },
  { word: "goirid", ipa: "/ˈkɤɾʲɪtʲ/" },
  { word: "druim", ipa: "/t̪ɾɯim/" },
  { word: "caol", ipa: "/kʰɯːɫ̪/" },
  { word: "cas", ipa: "/kʰas/" },
  { word: "teanga", ipa: "/ˈt͡ʃʰɛŋkə/" },
  { word: "falt liath", ipa: "no ipa found" },
  { word: "falt ruadh", ipa: "no ipa found" },
  { word: "falt bàn", ipa: "no ipa found" },
  { word: "glan", ipa: "/ɡlan/" },
  { word: "salach", ipa: "/ˈsaɫ̪əx/" },
  { word: "air", ipa: "/ɛrʲ/" },
  { word: "oirre", ipa: "/ˈɔrˠə/" },
  { word: "dubh", ipa: "/t̪uh/" },
  { word: "ialtag", ipa: "/ˈiəl̪ˠt̪ək/" },
  { word: "staidhre", ipa: "/ˈs̪t̪aiɾʲə/" },
  { word: "eaglais", ipa: "/ˈekl̪ˠɪʃ/" },
  { word: "nathair", ipa: "/ˈn̪ˠahɪɾʲ/" },
  { word: "rèis", ipa: "/rˠeːʃ/" },
  { word: "bò", ipa: "/poː/" },
  { word: "grian", ipa: "/ˈcɾʲian/" },
  { word: "caileag", ipa: "/ˈkʰalak/" },
  { word: "bean", ipa: "[b̥ɛn]" },
  { word: "piuthar", ipa: "/h/" },
  { word: "gàidhlig", ipa: "/gaːlɪgʲ/" },
  { word: "clach", ipa: "/kʰl̪ˠax/" },
  { word: "fiacaill", ipa: "/ˈfiəxkɪʎ/" },
  { word: "feòrag", ipa: "/ˈfjɔːɾak/" },
  { word: "feannag", ipa: "/ˈfjan̪ˠak/" },
  { word: "crùbag", ipa: "/ˈkʰɾuːpak/" },
  { word: "fuil", ipa: "/ful/" },
  { word: "sràid", ipa: "/srɑːt͡ʃ/" },
  { word: "sìde", ipa: "/ˈʃiːtʲə/" },
  { word: "slige", ipa: "/ˈʃlʲɪkʲə/" },
  { word: "ceart", ipa: "/ˈkʲʰarˠʃt/" },
  { word: "ceàrr", ipa: "/kʲʰaːrˠ/" },
  { word: "Catrìona", ipa: "/kaˈtriənə/" },
  { word: "coibhneil", ipa: "/ˈkʰɤiɲal/" },
  { word: "càirdeil", ipa: "/ˈkʰaːrtʲal/" },
  { word: "Eubha", ipa: "/ˈiəvə/" },
  { word: "Mairead", ipa: "/ˈmaɾʲət̪/" },
  { word: "inntinneach", ipa: "/ˈĩːɲtʲɪɲəx/" },
  { word: "annasach", ipa: "/ˈan̪ˠəs̪əx/" },
  { word: "Ealasaid", ipa: "/ˈɛl̪ˠəs̪ɪtʲ/" },
  { word: "Leagsaidh", ipa: "/ˈʎeks̪ɪ/" },
  { word: "Flòraidh", ipa: "/ˈfl̪ˠɔːɾɪ/" },
  { word: "pòsta", ipa: "/ˈpʰɔːs̪t̪ə/" },
  { word: "còmhla ri", ipa: "no ipa found" },
  { word: "a' leughadh", ipa: "/ˈʎeːvəɣ/" },
  { word: "a' sgrìobhadh", ipa: "/ˈs̪kɾʲiːvəɣ/" },
  { word: "faisg air", ipa: "no ipa found" },
  { word: "an-dè", ipa: "/ənˈtʲeː/" },
  { word: "litir", ipa: "/ˈʎihtʲɪɾʲ/" },
  { word: "a' coiseachd", ipa: "/ˈkʰɔʃəxk/" },
  { word: "a' ruith", ipa: "/rˠih/" },
  { word: "leabharlann", ipa: "/ˈʎo.əɾ.l̪ˠən̪ˠ/" },
  { word: "a-raoir", ipa: "/əˈɾɤiɾʲ/" },
  { word: "a' snàmh", ipa: "/sn̪ˠãːv/" },
  { word: "a' cadal", ipa: "/ˈkʰat̪aɫ̪/" },
  { word: "a-riamh", ipa: "/əˈrʲiəv/" },
  { word: "a' dol", ipa: "/dôːl/" },
  { word: "feasgar an-dè", ipa: "no ipa found" },
  { word: "madainn an-dè", ipa: "no ipa found" },
  { word: "a' seinn", ipa: "/ʃeiɲ/" },
  { word: "a' sreap", ipa: "/strɛhp/" },
  { word: "màrtainn", ipa: "/maːRʃdɪNʲ/" },
  { word: "tuathanas", ipa: "/ˈtʰuəhənəs̪/" },
  { word: "drochaid", ipa: "/drɔxɪdʲ/" },
  { word: "còmhla", ipa: "/kʰɔ̃ːɫ̪ə/" },
  { word: "a' tighinn", ipa: "/tʲi.ɪNʲ/" },
  { word: "trèana", ipa: "/trɛːn/" },
  { word: "plèana", ipa: "/ˈpʰlɛːnə/" },
  { word: "bus", ipa: "/pus̪/" },
  { word: "stèisean", ipa: "/sdɛːʃən/" },
  { word: "trèanaichean", ipa: "no ipa found" },
  { word: "busaichean", ipa: "no ipa found" },
  { word: "bàta", ipa: "/paːʰt̪ə/" },
  { word: "càr", ipa: "/kʰaːɾ/" },
  { word: "a' falbh", ipa: "/ˈfa.ɫ̪av/" },
  { word: "daor", ipa: "/t̪ɯːɾ/" },
  { word: "saor", ipa: "/s̪ɯːɾ/" },
  { word: "dìreach", ipa: "/ˈtʲiːɾʲəx/" },
  { word: "falbh", ipa: "/ˈfa.ɫ̪av/" },
  { word: "eilean", ipa: "/elan/" },
  { word: "uinneag", ipa: "/ɯNʲag/" },
  { word: "stad", ipa: "/stɑːd/" },
  { word: "tiogaid", ipa: "no ipa found" },
  { word: "airgead", ipa: "/ˈɛɾʲɛkʲət/" },
  { word: "seall air", ipa: "no ipa found" },
  { word: "fosgailte", ipa: "[ˈfoskəlʲtʲə]" },
  { word: "dùinte", ipa: "/ˈt̪uːɲtʲə/" },
  { word: "an t-eilean sgitheanach", ipa: "/əNʲ tʲelan sgʲi.anəx/" },
  { word: "a' draibheadh", ipa: "/ˈt̪ˠɾaivəɣ/" },
  { word: "cudromach", ipa: "/ˈkʰut̪ɾəməx/" },
  { word: "bochd", ipa: "[pɔxk]" },
  { word: "a sheumais", ipa: "/ʃeːməs/" },
  { word: "a chaluim", ipa: "/kaLəm/" },
  { word: "a phàdraig", ipa: "/paːdrɪgʲ/" },
  { word: "a thormoid", ipa: "/tɔrɔməd/" },
  { word: "Tormod", ipa: "/tɔrɔməd/" },
  { word: "Pàdraig", ipa: "/paːdrɪgʲ/" },
  { word: "Uilleam", ipa: "/ˈɯʎəm/" },
  { word: "Uilleim", ipa: "/ɯLʲam/" },
  { word: "Aonghas", ipa: "/ɯnɯ.əs/" },
  { word: "Aonghais", ipa: "/ɯnɯ.əs/" },
  { word: "Eòghann", ipa: "/joː.ən̪ˠ/" },
  { word: "Eòghainn", ipa: "/joː.əN/" },
  { word: "Ruairidh", ipa: "/Ruərɪ/" },
  { word: "a ruairidh", ipa: "/Ruərɪ/" },
  { word: "Niall", ipa: "/NʲiaL/" },
  { word: "slaodach", ipa: "/ˈs̪l̪ˠɯːt̪əx/" },
  { word: "a nèill", ipa: "/NʲiaL/" },
  { word: "Fionnlagh", ipa: "/fjũːNLəɣ/" },
  { word: "Fhionnlaigh", ipa: "/fjũːNLəɣ/" },
  { word: "Frìseal", ipa: "/frʲiʃəL/" },
  { word: "a fhrìseil", ipa: "/frʲiʃəL/" },
  { word: "glic", ipa: "/kliçc/" },
  { word: "Fearghas", ipa: "/ˈfɛrɛɣəs/" },
  { word: "Fhearghais", ipa: "/fɛrɛɣəs/" },
  { word: "greas ort", ipa: "no ipa found" },
  { word: "mise", ipa: "/ˈmiʃə/" },
  { word: "bòidheach", ipa: "/ˈpɔːjəx/" },
  { word: "làidir", ipa: "/ˈl̪ˠaːtʲɪɾʲ/" },
  { word: "lag", ipa: "/lɑːɡ/" },
  { word: "acras", ipa: "/aʰkʰɾəs̪/" },
  { word: "eagal", ipa: "/ekəl/" },
  { word: "oirnn", ipa: "/ɔrˠɲ/" },
  { word: "thusa", ipa: "/ˈ(h)us̪ə/" },
  { word: "uabhasach", ipa: "/ˈuəvəs̪əx/" },
  { word: "sibhse", ipa: "/ˈʃivʃə/" },
  { word: "pathadh", ipa: "/pa.əɣ/" },
  { word: "fearg", ipa: "/fɛrɛg/" },
  { word: "esan", ipa: "/ˈɛs̪ən̪ˠ/" },
  { word: "dragh", ipa: "/t̪ɾɤɣ/" },
  { word: "ise", ipa: "/ˈiʃə/" },
  { word: "cabhag", ipa: "/ˈkʰavak/" },
  { word: "cnatan", ipa: "/ˈkʰɾãhtan/" },
  { word: "orra", ipa: "/ˈɔɾə/" },
  { word: "oirbh", ipa: "/ˈɔɾʲəv/" },
  { word: "an dèideadh", ipa: "no ipa found" },
  { word: "mìcheal", ipa: "/miːçəL/" },
  { word: "gaol", ipa: "/kɯːl̪ˠ/" },
  { word: "gràin", ipa: "/graːNʲ/" },
  { word: "A' chuimrigh", ipa: "/ə xɯmɯrɪ/" },
  { word: "A' ghearmailt", ipa: "no ipa found" },
  { word: "Eilean mhanainn", ipa: "/elanˈvanɪNʲ/" },
  { word: "A' phòlainn", ipa: "no ipa found" },
  { word: "a' phìob-mhòr", ipa: "/pibˈvoːr/" },
  { word: "Innis tìle", ipa: "no ipa found" },
  { word: "ceòl", ipa: "/kʲʰɔːɫ̪/" },
  { word: "A' bheilg", ipa: "/əˈvelegʲ/" },
  { word: "A' phortagail", ipa: "no ipa found" },
  { word: "ro", ipa: "/ˈro/" },
  { word: "clann", ipa: "/kʰl̪ˠaun̪ˠ/" },
  { word: "craobh", ipa: "/kʰɾɯːv/" },
  { word: "a' ghrèig", ipa: "/grʲeːg/" },
  { word: "An roinn-eòrpa", ipa: "no ipa found" },
  { word: "An spàinn", ipa: "/əˈsbaːNʲ/" },
  { word: "An rìoghachd aonaichte", ipa: "no ipa found" },
  { word: "An ruis", ipa: "/əˈRuʃ/" },
  { word: "An tuirc", ipa: "/əN turçgʲ/" },
  { word: "rathad", ipa: "/rˠahad/" },
  { word: "An fhraing", ipa: "/ə ˈRaŋʲgʲ/" },
  { word: "An t-suain", ipa: "/əN tuəNʲ/" },
  { word: "A' chòrn", ipa: "no ipa found" },
  { word: "Breatainn", ipa: "/ˈpɾʲɛht̪ɪɲ/" },
  { word: "fidheall", ipa: "/fiːjəL/" },
  { word: "fionnlann", ipa: "no ipa found" },
  { word: "seacaid", ipa: "/ˈʃɛxkatʲ/" },
  { word: "An eadailt", ipa: "/əNʲ edaldʲ/" },
  { word: "An ostair", ipa: "no ipa found" },
  { word: "An eilbheis", ipa: "/əNʲ elevɪʃ/" },
  { word: "Sìona", ipa: "/ʃiːna/" },
  { word: "A' bhreatann bheag", ipa: "no ipa found" },
  { word: "abhainn", ipa: "/ˈa.wɪɲ/" },
  { word: "a-staigh", ipa: "/əˈsdɤj/" },
  { word: "niseag", ipa: "/Nʲiʃag/" },
  { word: "cat", ipa: "/kʰaʰt̪/" },
  { word: "peata", ipa: "/pɛhdə/" },
  { word: "pàirc", ipa: "/pʰaːɾʲçkʲ/" },
  { word: "cù", ipa: "/kʰuː/" },
  { word: "eagalach", ipa: "/ˈekəl̪ˠəx/" },
  { word: "each", ipa: "/ɛx/" },
  { word: "radan", ipa: "/ˈra.tən/" },
  { word: "baga", ipa: "/ˈbakə/" },
  { word: "a-mach", ipa: "/əˈmax/" },
  { word: "bìodach", ipa: "/piːtəx/" },
  { word: "feumail", ipa: "/feːmal/" },
  { word: "coineanach", ipa: "/ˈkʰɔɲanəx/" },
  { word: "a-steach", ipa: "/əˈʃdʲɛx/" },
  { word: "mathan", ipa: "/ˈma.han/" },
  { word: "tarbh", ipa: "[t̪ʰaɾav]" },
  { word: "broc", ipa: "/pɾɔʰk/" },
  { word: "gleann", ipa: "/klaun̪ˠ/" },
  { word: "caora", ipa: "[kʰɯːɾə]" },
  { word: "eun", ipa: "/ian/" },
  { word: "iasg", ipa: "/iəsk/" },
  { word: "coille", ipa: "/ˈkʰɤʎə/" },
  { word: "sligeanach", ipa: "/ʃLʲigʲanəx/" },
  { word: "dìleas", ipa: "/dʲiːləs/" },
  { word: "loch", ipa: "[ɫ̪ɔx]" },
  { word: "èirisgeidh", ipa: "/eːrʲɪʃgʲej/" },
  { word: "a' leum", ipa: "/ʎeːm/" },
  { word: "gràineag", ipa: "/ˈkɾaːɲak/" },
  { word: "leòmhann", ipa: "/ˈʎɔː.ən̪ˠ/" },
  { word: "feur", ipa: "/ˈfiəɾ/" },
  { word: "mo", ipa: "/mo/" },
  { word: "do", ipa: "/t̪ɔ/" },
  { word: "coltach ri", ipa: "no ipa found" },
  { word: "a' coimhead", ipa: "/ˈkʰɔ̃jət/" },
  { word: "sean", ipa: "/ʃɛn/" },
  { word: "stamag", ipa: "/s̪t̪ʰamak/" },
  { word: "tòn", ipa: "/tʰɔːn/" },
  { word: "sàbhailte", ipa: "/saːvaldʲə/" },
  { word: "glùn", ipa: "/gLuːn/" },
  { word: "bodhaig", ipa: "/po.ɪkʲ/" },
  { word: "gàirdean", ipa: "/gaːRdʲan/" },
  { word: "eadar", ipa: "/ˈet̪əɾ/" },
  { word: "ag èisteachd", ipa: "no ipa found" },
  { word: "briste", ipa: "/ˈpɾʲiʃtʲə/" },
  { word: "amhach", ipa: "/avɪç/" },
  { word: "a' dannsa", ipa: "/ˈt̪ãũn̪ˠs̪ə/" },
  { word: "corrag", ipa: "/ˈkʰɔrˠak/" },
  { word: "gleansach", ipa: "/ˈklɛnsəx/" },
  { word: "bàn", ipa: "/paːn/" },
  { word: "ruadh", ipa: "/rˠuəɣ/" },
  { word: "cugallach", ipa: "/kugəLəx/" },
  { word: "diluain", ipa: "/dʲɪˈLuəNʲ/" },
  { word: "dimàirt", ipa: "/dʲɪˈmaːRʃdʲ/" },
  { word: "a' sgioblachadh", ipa: "/sgʲibLəxəɣ/" },
  { word: "aon-deug", ipa: "no ipa found" },
  { word: "dà-dheug", ipa: "no ipa found" },
  { word: "seachd", ipa: "/ʃɛxk/" },
  { word: "diciadain", ipa: "/dʲɪˈkʲiədɪNʲ/" },
  { word: "diardaoin", ipa: "/dʲəRˈdɯːNʲ/" },
  { word: "trì-deug", ipa: "no ipa found" },
  { word: "ceithir-deug", ipa: "no ipa found" },
  { word: "còig-deug", ipa: "no ipa found" },
  { word: "ag èigheachd", ipa: "no ipa found" },
  { word: "ochd", ipa: "/ɔxk/" },
  { word: "dihaoine", ipa: "/dʲɪˈhɯːNʲə/" },
  { word: "disathairne", ipa: "/dʲɪˈsahəRNʲə/" },
  { word: "sia-deug", ipa: "no ipa found" },
  { word: "seachd-deug", ipa: "no ipa found" },
  { word: "ochd-deug", ipa: "no ipa found" },
  { word: "a-màireach", ipa: "/əˈmaːrʲəx/" },
  { word: "a' feuchainn", ipa: "/fiaxɪNʲ/" },
  { word: "Didòmhnaich", ipa: "/dʲɪˈdɔ̃nɪç/" },
  { word: "latha na sàbaid", ipa: "no ipa found" },
  { word: "naoi-deug", ipa: "no ipa found" },
  { word: "fichead", ipa: "/ˈfiçət̪/" },
  { word: "a' togail", ipa: "/togal/" },
  { word: "sinne", ipa: "/ˈʃiɲə/" },
  { word: "a-nochd", ipa: "/əˈn̪ˠɔ̃xk/" },
  { word: "iadsan", ipa: "/ˈiə̯t̪s̪ən̪ˠ/" },
  { word: "a dh'aithghearr", ipa: "/əˈɣɛçəR/" },
  { word: "air ais", ipa: "/ɛrʲ aʃ/" },
  { word: "na hearadh", ipa: "/nə hɛrəɣ/" },
  { word: "sàmhach", ipa: "/ˈs̪aːvəx/" },
  { word: "seachdain", ipa: "/ʃɛxgɛNʲ/" },
  { word: "a' coinneachadh", ipa: "/kɤNʲəxəɣ/" },
  { word: "cuideachail", ipa: "/ˈkʰutʲəxal/" },
  { word: "bràthair", ipa: "/braːhɪrʲ/" },
  { word: "pàrant", ipa: "/paːrəNd/" },
  { word: "facal", ipa: "/ˈfaxkəɫ/" },
  { word: "faclair", ipa: "/ˈfaxk.lˠ̪əɾʲ/" },
  { word: "caraid", ipa: "/kʰaɾɪtʲ/" },
  { word: "spaideil", ipa: "/ˈspatʲal/" },
  { word: "teaghlach", ipa: "/ˈtʃʰɤːɫ̪əx/" },
  { word: "modhail", ipa: "/ˈmɔɣal/" },
  { word: "an duine agad", ipa: "no ipa found" },
  { word: "co-ogha", ipa: "/kɔ o.ə/" },
  { word: "mìorbhaileach", ipa: "/ˈmiəɾvələx/" },
  { word: "mì-mhodhail", ipa: "/ˈmiː ˌvɔɣal/" },
  { word: "seada", ipa: "/ʃedə/" },
  { word: "mo chreach", ipa: "/məˈxʲɾʲɛx/" },
  { word: "dhachaigh", ipa: "/ˈɣa.xɪ/" },
  { word: "mac", ipa: "/maʰk/" },
  { word: "athair", ipa: "/ˈahəɾʲ/" },
  { word: "nighean", ipa: "/ɲiː.an̪ˠ/" },
  { word: "doileag", ipa: "/dɔlag/" },
  { word: "seanair", ipa: "/ˈʃɛnɪɾʲ/" },
  { word: "thalla", ipa: "/haLə/" },
  { word: "seanmhair", ipa: "/ˈʃɛ.nə.vɛɾʲ/" },
  { word: "beurla", ipa: "/bjɤːRLə/" },
  { word: "dèideag", ipa: "/dʲeːdʲag/" },
  { word: "taigh-seinnse", ipa: "/tʰəˈʃeiɲʃə/" },
  { word: "ball-coise", ipa: "/paul̪ˠ kʰɔʃə/" },
  { word: "iomain", ipa: "/ˈimɛɲ/" },
  { word: "a h-uile", ipa: "no ipa found" },
  { word: "goilf", ipa: "/kɔlf/" },
  { word: "geama", ipa: "/ˈcɛmə/" },
  { word: "ball", ipa: "/paul̪ˠ/" },
  { word: "cunnartach", ipa: "/ˈkʰun̪ˠərˠʃtəx/" },
  { word: "math air", ipa: "no ipa found" },
  { word: "rothair", ipa: "/rˠɔhɪɾʲ/" },
  { word: "ag iasgach", ipa: "no ipa found" },
  { word: "deiseil", ipa: "/ˈtʲeʃal/" },
  { word: "a' cluiche", ipa: "/ˈkʰl̪ˠuçə/" },
  { word: "tràigh", ipa: "/tʰɾaːj/" },
  { word: "teanas", ipa: "no ipa found" },
  { word: "a' seòladh", ipa: "/ˈʃɔːɫ̪əɣ/" },
  { word: "rothaireachd", ipa: "/Rɔhɛrʲəxg/" },
  { word: "rugbaidh", ipa: "/Rugbɪ/" },
  { word: "an gearasdan", ipa: "no ipa found" },
  { word: "còmhla ri chèile", ipa: "no ipa found" },
  { word: "ball-basgaid", ipa: "/pauɫ̪ paskɪtʲ/" },
  { word: "uaireannan", ipa: "/ˈuəɾʲən̪ˠən/" },
  { word: "an-dràsta fhèin", ipa: "no ipa found" },
  { word: "spòrs", ipa: "/sbɔːRs/" },
  { word: "furasta", ipa: "/ˈfuɾəs̪t̪ə/" },
  { word: "math dhut", ipa: "no ipa found" },
  { word: "dannsa gàidhealach", ipa: "no ipa found" },
  { word: "dhut", ipa: "/ɣuht̪/" },
  { word: "doirbh", ipa: "/ˈt̪ɤɾʲɤv/" },
  { word: "a' ghàidhealtachd", ipa: "/əˈɣɛː.əLdəxg/" },
  { word: "a' sgitheadh", ipa: "/sgʲiː.əɣ/" },
  { word: "a' ghalldachd", ipa: "/ə ɣauLdəxg/" },
  { word: "an uairsin", ipa: "/əN uəRʃɪn/" },
  { word: "rèidio", ipa: "/Reːdʲɔ/" },
  { word: "telebhisean", ipa: "no ipa found" },
  { word: "milis", ipa: "/ˈmiləʃ/" },
  { word: "searbh", ipa: "/ˈʃɛɾˠɛv/" },
  { word: "taigh-bìdh", ipa: "/ˈtʰɤj ˈpiːj/" },
  { word: "cidsin", ipa: "/ˈkʲʰitʲʃɪn/" },
  { word: "seòclaid", ipa: "/ʃɔːxgLɪdʲ/" },
  { word: "am bu toil leat", ipa: "no ipa found" },
  { word: "dinnear", ipa: "/dʲiːNʲər/" },
  { word: "bracaist", ipa: "/ˈpɾaxkəʃtʲ/" },
  { word: "ith", ipa: "/iç/" },
  { word: "ceapaire", ipa: "/ˈkʲʰɛhpəɾʲə/" },
  { word: "cus", ipa: "/kʰus̪/" },
  { word: "aran-milis", ipa: "no ipa found" },
  { word: "marag-dhubh", ipa: "/maragˈɣu/" },
  { word: "spìosrach", ipa: "/ˈs̪piːs̪ɾəx/" },
  { word: "gabh", ipa: "/kav/" },
  { word: "a' gabhail", ipa: "/ˈkahal/" },
  { word: "bradan", ipa: "/ˈpɾatan/" },
  { word: "feòil", ipa: "/fjɔːl/" },
  { word: "na ith", ipa: "no ipa found" },
  { word: "na gabh", ipa: "no ipa found" },
  { word: "measan", ipa: "/mesan/" },
  { word: "glasraich", ipa: "/gLasrɪç/" },
  { word: "truinnsear", ipa: "/trɯ̃ĩNʲʃər/" },
  { word: "is fheàrr leam", ipa: "/ʃɛ ʃaːR ləm maˈLavɪ/" },
  { word: "glainne", ipa: "/ˈkl̪ˠaɲə/" },
  { word: "cupa", ipa: "/kʰuʰpʰə/" },
  { word: "mòr-bhùth", ipa: "no ipa found" },
  { word: "albannach", ipa: "/aLabəNəx/" },
  { word: "eadailteach", ipa: "/edaldʲəx/" },
  { word: "sìonach", ipa: "/ʃiːnəx/" },
  { word: "sgreamhail", ipa: "/ˈs̪kɾʲɛval/" },
  { word: "seòclaid theth", ipa: "no ipa found" },
  { word: "dè an uair a tha e", ipa: "no ipa found" },
  { word: "uair", ipa: "/uərʲ/" },
  { word: "dà uair", ipa: "no ipa found" },
  { word: "an dèidh", ipa: "/əɲˈtʲeː/" },
  { word: "cèilidh", ipa: "/ˈkʲʰeːli/" },
  { word: "partaidh", ipa: "/paːRʃdɪ/" },
  { word: "madainn an-diugh", ipa: "no ipa found" },
  { word: "ma-thà", ipa: "/maˈhaː/" },
  { word: "sin", ipa: "[ʃɪn]" },
  { word: "uairean", ipa: "/uərʲ/" },
  { word: "cloc", ipa: "/klɔk/" },
  { word: "feasgar an-diugh", ipa: "no ipa found" },
  { word: "boireannach", ipa: "/ˈpɔɾʲən̪ˠəx/" },
  { word: "cuin", ipa: "/kʰuɲ/" },
  { word: "feasgar a-màireach", ipa: "no ipa found" },
  { word: "tràth", ipa: "/t̪ʰɾaː/" },
  { word: "fadalach", ipa: "/ˈfatəl̪ˠəx/" },
  { word: "sin thu fhèin", ipa: "no ipa found" },
  { word: "leth uair an dèidh", ipa: "no ipa found" },
  { word: "dà mhionaid", ipa: "no ipa found" },
  { word: "madainn a-màireach", ipa: "no ipa found" },
  { word: "fichead 's a h-aon", ipa: "no ipa found" },
  { word: "fichead 's a dhà", ipa: "no ipa found" },
  { word: "fichead 's a...", ipa: "no ipa found" },
  { word: "aon uair deug", ipa: "no ipa found" },
  { word: "cairteal an dèidh", ipa: "no ipa found" },
  { word: "fichead 's a h-ochd", ipa: "no ipa found" },
  { word: "coma", ipa: "/ˈkʰomə/" },
  { word: "mionaid", ipa: "/ˈminətʲ/" },
  { word: "dà uair dheug", ipa: "no ipa found" },
  { word: "cairteal gu", ipa: "no ipa found" },
  { word: "dè an aois a", ipa: "no ipa found" },
  { word: "bliadhna", ipa: "/bliən̪ˠə/" },
  { word: "am-bliadhna", ipa: "no ipa found" },
  { word: "mìos", ipa: "/miəs̪/" },
  { word: "aois", ipa: "[ɯːʃ]" },
  { word: "turadh", ipa: "/ˈtʰɯɾəɣ/" },
  { word: "gu dearbh", ipa: "no ipa found" },
  { word: "tioram", ipa: "/ˈtʃʰiɾəm/" },
  { word: "oidhche", ipa: "/ˈɤ̃ĩçə/" },
  { word: "gealach", ipa: "/gʲaLəx/" },
  { word: "deagh", ipa: "/tʲoː/" },
  { word: "soilleir", ipa: "/ˈsɤʎɪɾʲ/" },
  { word: "clachan-meallain", ipa: "no ipa found" },
  { word: "reòite", ipa: "/Rɔːdʲə/" },
  { word: "a' fàs", ipa: "/faːs/" },
  { word: "caran", ipa: "/kʰaɾan/" },
  { word: "dìle", ipa: "/dʲiːlə/" },
  { word: "droch", ipa: "/droːχ/" },
  { word: "a' cur", ipa: "/kur/" },
  { word: "deigh", ipa: "/tʲej/" },
  { word: "bog fliuch", ipa: "no ipa found" },
  { word: "cuir", ipa: "/kʰuɾʲ/" },
  { word: "sgrathail", ipa: "/ˈskɾahal/" },
  { word: "feasgar", ipa: "/ˈfes̪kər/" },
  { word: "mhadainn", ipa: "/madɪNʲ/" },
  { word: "suas", ipa: "/suəs/" },
  { word: "àite", ipa: "[aːʰtʲɪ]" },
  { word: "latha", ipa: "/l̪ˠa.a/" },
  { word: "ciùin", ipa: "/kʰʲuːɲ/" },
  { word: "miotagan", ipa: "/mihdag/" },
  { word: "a' mheanbh-chuileag", ipa: "/mɛnɛvxulag/" },
  { word: "sìos", ipa: "/ʃiəs̪/" },
  { word: "muir", ipa: "/murʲ/" },
  { word: "adhar", ipa: "/a.əɾ/" },
  { word: "trom", ipa: "/t̪ʰɾɔum/" },
  { word: "aotrom", ipa: "/ˈɯːtɾəm/" },
  { word: "seòmar", ipa: "/ʃɔːmər/" },
  { word: "togalach", ipa: "/ˈtʰokəl̪ˠəx/" },
  { word: "forca", ipa: "/ˈfɔrˠxkə/" },
  { word: "faigh", ipa: "/faç/" },
  { word: "peann", ipa: "/pʰjaun̪ˠ/" },
  { word: "spàin", ipa: "/sbaːNʲ/" },
  { word: "làr", ipa: "[ɫ̪aːɾ]" },
  { word: "fada air falbh", ipa: "no ipa found" },
  { word: "na tog", ipa: "no ipa found" },
  { word: "tog", ipa: "/tʰok/" },
  { word: "flùr", ipa: "/fl̪ˠuːɾ/" },
  { word: "taigh", ipa: "/tʰɤj/" },
  { word: "fear", ipa: "/fɛɾ/" },
  { word: "tè", ipa: "[tɛ˨˩]" },
  { word: "mòra", ipa: "/ˈmoːɾə/" },
  { word: "beaga", ipa: "/beg ~ Lɤɣə/" },
  { word: "dè", ipa: "/tʲeː/" },
  { word: "rud", ipa: "/rˠut̪/" },
  { word: "thoir dhomh", ipa: "no ipa found" },
  { word: "ùra", ipa: "/ˈuːɾˠə/" },
  { word: "dearga", ipa: "no ipa found" },
  { word: "beò", ipa: "/pjɔː/" },
  { word: "marbh", ipa: "/maɾav/" },
  { word: "siud", ipa: "[ʃʲud]" },
  { word: "matha", ipa: "/mah/" },
  { word: "nurs", ipa: "no ipa found" },
  { word: "dotair", ipa: "/dɔhdɛɾʲ/" },
  { word: "tidsear", ipa: "no ipa found" },
  { word: "glanadair", ipa: "/gLanədɪrʲ/" },
  { word: "a' glanadh", ipa: "/gLanəɣ/" },
  { word: "poileas", ipa: "/pɔləs/" },
  { word: "a' teagasg", ipa: "/ˈtʃʰekəsk/" },
  { word: "banca", ipa: "/baŋgə/" },
  { word: "ollamh", ipa: "/ˈɔl̪ˠəv/" },
  { word: "colaiste", ipa: "/ˈkʰɔɫ̪ɪʃtʲə/" },
  { word: "iasgair", ipa: "/ˈiəs̪kɛɾʲ/" },
  { word: "tuathanach", ipa: "/tuəhənəx/" },
  { word: "rùnaire", ipa: "/Ruːnɪrʲə/" },
  { word: "a' suidhe", ipa: "/ˈs̪ɯi.ə/" },
  { word: "sam bith", ipa: "/s̪əmˈpih/" },
  { word: "a' seasamh", ipa: "/ˈʃes̪əv/" },
  { word: "neach-ciùil", ipa: "/ˌɲɛxˈkʲʰuːlʲ/" },
  { word: "neach-bùtha", ipa: "/ˌɲɛxˈpuː/" },
  { word: "neach-frithealaidh", ipa: "/ɲɛxˈfɾʲihəl̪ˠɪj/" },
  { word: "an siud", ipa: "/əNʲˈʃid/" },
  { word: "croit", ipa: "/kʰɾɔhtʲ/" },
  { word: "croitear", ipa: "/krɔhdʲər/" },
  { word: "a' sabaid", ipa: "/ˈsapatʲ/" },
  { word: "sagart", ipa: "/ˈs̪akərʃt/" },
  { word: "ministear", ipa: "/minɪʃdʲər/" },
  { word: "neach-smàlaidh", ipa: "no ipa found" },
  { word: "feòladair", ipa: "/ˈfjɔːl̪ˠət̪əɾʲ/" },
  { word: "ge-tà", ipa: "/kəˈtʰaː/" },
  { word: "ailtire", ipa: "/ˈaʎtʲɪɾʲə/" },
  { word: "còcaire", ipa: "/ˈkʰɔːxkəɾʲə/" },
  { word: "clachair", ipa: "/ˈkʰl̪ˠaxɛɾʲ/" },
  { word: "comasach", ipa: "/ˈkʰoməs̪əx/" },
  { word: "dìcheallach", ipa: "/ˈtʲiːçəl̪ˠəx/" },
  { word: "leisg", ipa: "/ʎeʃkʲ/" },
  { word: "ceist", ipa: "[kʰʲeʃtʲ]" },
  { word: "fad an latha", ipa: "no ipa found" },
  { word: "a' còcaireachd", ipa: "/ˈkʰɔːxkɛɾʲəxk/" },
  { word: "is math sin", ipa: "no ipa found" },
  { word: "làn", ipa: "/l̪ˠaːn/" },
  { word: "falamh", ipa: "[ˈfaɫ̪əv]" },
  { word: "cat-fiadhaich", ipa: "/kahdˈfiə.ɪç/" },
  { word: "seas", ipa: "/ˈseas/" },
  { word: "suidh", ipa: "/suj/" },
  { word: "b' àill leibh", ipa: "no ipa found" },
  { word: "cathair", ipa: "/ˈkʰahɪɾʲ/" },
  { word: "leisgeadair", ipa: "/ˈʎeʃkʲətɛɾʲ/" },
  { word: "fiadh", ipa: "/ˈfiə̯ɣ/" },
  { word: "stiall ort", ipa: "no ipa found" },
  { word: "fileanta", ipa: "/ˈfilən̪ˠt̪ə/" },
  { word: "foighidneach", ipa: "/ˈfɤjɪtʲnəx/" },
  { word: "sgarbh", ipa: "/ˈskaɾav/" },
  { word: "ròn", ipa: "/rɔːn/" },
  { word: "bodach", ipa: "/ˈpɔt̪əx/" },
  { word: "cailleach", ipa: "/ˈkʰaʎəx/" },
  { word: "cruaidh", ipa: "/kruəj/" },
  { word: "bàrd", ipa: "/paːrˠʃt̪/" },
  { word: "sona", ipa: "[sɔnə]" },
  { word: "coltach", ipa: "/ˈkʰɔl̪ˠəx/" },
  { word: "rudeigin", ipa: "/Rudəgʲɪn/" },
  { word: "cuideigin", ipa: "/ˈkʰutʲecɪn/" },
  { word: "bog", ipa: "[b̊oɡ̊]" },
  { word: "iarann", ipa: "/iəRəN/" },
  { word: "lofa", ipa: "/ˈɫ̪ɔfə/" },
  { word: "sionnach", ipa: "/ˈʃun̪ˠəx/" },
  { word: "seann", ipa: "/ʃãũN/" },
  { word: "iongantach", ipa: "/ˈĩə̃n̪ˠt̪əx/" },
  { word: "mil", ipa: "/mil/" },
  { word: "ball iomain", ipa: "no ipa found" },
  { word: "geàrr", ipa: "/kʲaːrˠ/" },
  { word: "seilcheig", ipa: "no ipa found" },
  { word: "seòlta", ipa: "/ʃɔːLdə/" },
  { word: "deònach", ipa: "/tʲɔːnəx/" },
  { word: "bruidhinn", ipa: "/ˈpɾi.ɪɲ/" },
  { word: "ceap breatainn", ipa: "no ipa found" },
  { word: "fraingis", ipa: "/fraiŋʲgʲɪʃ/" },
  { word: "rium", ipa: "/ɾʲum/" },
  { word: "taingeil", ipa: "/ˈtʰaiŋʲkʲal/" },
  { word: "èist", ipa: "/eːʃtʲ/" },
  { word: "gàidhlig na h-èireann", ipa: "no ipa found" },
  { word: "gearmailtis", ipa: "/gʲɛrɛmaldʲɪʃ/" },
  { word: "cànan", ipa: "/ˈkʰaːnan/" },
  { word: "riut", ipa: "/rʲi ~ rʲuːm rʲuhd rʲiʃ rʲi.ə rɯiNʲ rɯiv ru.ə/" },
  { word: "ribh", ipa: "/rʲi ~ rʲuːm rʲuhd rʲiʃ rʲi.ə rɯiNʲ rɯiv ru.ə/" },
  { word: "èistibh", ipa: "/ˈeːʃtʲɪv/" },
  { word: "ionnsaich", ipa: "/ˈjũːn̪ˠsɪç/" },
  { word: "a’ bheurla ghallda", ipa: "no ipa found" },
  { word: "ris", ipa: "[ɾʲiʃ]" },
  { word: "cuimris", ipa: "/kɯmɯrʲɪʃ/" },
  { word: "còrnais", ipa: "/kɔːRNɪʃ/" },
  { word: "cànan soidhnidh bhreatainn", ipa: "no ipa found" },
  { word: "ionnsaichibh", ipa: "/ˈjũːn̪ˠsɪçɪv/" },
  { word: "rithe", ipa: "/rʲi ~ rʲuːm rʲuhd rʲiʃ rʲi.ə rɯiNʲ rɯiv ru.ə/" },
  { word: "càirdeach", ipa: "/ˈkʰaːrtʲəx/" },
  { word: "spainntis", ipa: "/sbaːNʲdʲɪʃ/" },
  { word: "ceilteach", ipa: "/kʲeldʲəx/" },
  { word: "gàidhlig mhanainn", ipa: "no ipa found" },
  { word: "cànan-soidhnidh aimearaga", ipa: "no ipa found" },
  { word: "seòladair", ipa: "/ˈʃɔːl̪ˠət̪ɛɾʲ/" },
  { word: "muc-mhara", ipa: "/muxkˈvaɾə/" },
  { word: "hiort", ipa: "/hiRʃd/" },
  { word: "rach fodha", ipa: "/Rax fo.ə/" },
  { word: "sgileil", ipa: "/ˈskʲilal/" },
  { word: "sgiobair", ipa: "/ˈskʲipɛɾʲ/" },
  { word: "air bòrd", ipa: "no ipa found" },
  { word: "taigh-solais", ipa: "/tʰɤjˈsɔl̪ˠɪʃ/" },
  { word: "cuan", ipa: "/kʰuan/" },
  { word: "leumadair", ipa: "/ˈʎeːmət̪ɛɾʲ/" },
  { word: "tonn", ipa: "/tʰɔun̪ˠ/" },
  { word: "farsaing", ipa: "/faɾs̪ɪŋʲkʲ/" },
  { word: "a' sgreuchail", ipa: "/ˈs̪kɾʲiaxal/" },
  { word: "bhatarsaigh", ipa: "/vahdəRsaj/" },
  { word: "cearban", ipa: "/ˈkʲʰaɾapan/" },
  { word: "faoileag", ipa: "/ˈfɯːlak/" },
  { word: "spùinneadair-mara", ipa: "no ipa found" },
  { word: "Malaig", ipa: "no ipa found" },
  { word: "tìr", ipa: "/tʲiːrʲ/" },
  { word: "ratharsair", ipa: "/Ra.əRsɪrʲ/" },
  { word: "feamainn", ipa: "/ˈfemɪɲ/" },
  { word: "ochd-chasach", ipa: "/ˌɔxkˈkas̪əx/" },
  { word: "pitheid", ipa: "/ˈpʰi.ɛtʲ/" },
  { word: "feumaidh", ipa: "/ˈfeːmɪ/" },
  { word: "ruith", ipa: "/rˠih/" },
  { word: "sgioba", ipa: "/sgʲibə/" },
  { word: "a' fighe", ipa: "/fi.ə/" },
  { word: "geansaidh", ipa: "/ˈkʲɛns̪ɪ/" },
  { word: "sgioblaich", ipa: "/ˈskʲipl̪ˠɪç/" },
  { word: "coisich", ipa: "/kɔʃɪç/" },
  { word: "taigh-dhealbh", ipa: "[təjˈjaləv]" },
  { word: "cluich", ipa: "/kʰl̪ˠɪç/" },
  { word: "air falbh", ipa: "/ɛɾʲ ˈfal̪ˠəv/" },
  { word: "ad", ipa: "[at̪]" },
  { word: "còmhlan-ciùil", ipa: "no ipa found" },
  { word: "còisir", ipa: "/kɔːʃɪrʲ/" },
  { word: "seinn", ipa: "/ʃeiɲ/" },
  { word: "ruithibh", ipa: "/dʲãũNrɪ/" },
  { word: "cluichibh", ipa: "/kLuç/" },
  { word: "tàileasg", ipa: "/ˈtʰaːləs̪k/" },
  { word: "geama-bùird", ipa: "no ipa found" },
  { word: "coisichibh", ipa: "/kɔʃɪç/" },
  { word: "pàipear-naidheachd", ipa: "no ipa found" },
  { word: "nobhail", ipa: "/ˈn̪ˠɔval/" },
  { word: "leugh", ipa: "/ʎeːv/" },
  { word: "pròiseil", ipa: "/ˈpʰɾɔːʃɛl/" },
  { word: "seinnibh", ipa: "/ʃeiNʲ/" },
  { word: "sgrìobh", ipa: "/s̪kɾʲiːv/" },
  { word: "bi", ipa: "/pi/" },
  { word: "foghlam", ipa: "/ˈfɤːl̪ˠəm/" },
  { word: "sgeulachd", ipa: "/ˈskʲiəl̪ˠəxk/" },
  { word: "aiste", ipa: "/ˈaʃtʲə/" },
  { word: "faiceallach", ipa: "/ˈfaçkʲəl̪ˠəx/" },
  { word: "a' cuideachadh", ipa: "/ˈkʰutʲəxəɣ/" },
  { word: "matamataig", ipa: "/mat̪ʰəˈmat̪ʰɪkʲ/" },
  { word: "leasan", ipa: "/ˈʎɛs̪ən/" },
  { word: "sgoilear", ipa: "/ˈs̪kɔlɛɾ/" },
  { word: "obair-dachaigh", ipa: "no ipa found" },
  { word: "cha do sgrìobh", ipa: "no ipa found" },
  { word: "bòrd-geal", ipa: "no ipa found" },
  { word: "pàipear", ipa: "[ˈpʰɛːʰpəɾʲ]" },
  { word: "bun-sgoil", ipa: "/bunsgɔl/" },
  { word: "cha do leugh", ipa: "no ipa found" },
  { word: "seòmar-teagaisg", ipa: "no ipa found" },
  { word: "cleachd", ipa: "/kʰlɛxk/" },
  { word: "àrd-sgoil", ipa: "/aːRdsgɔl/" },
  { word: "bòrd-dubh", ipa: "no ipa found" },
  { word: "glaodh", ipa: "/kl̪ˠɯː/" },
  { word: "a' cleachdadh", ipa: "/ˈkʰlɛxkəɣ/" },
  { word: "peant", ipa: "/pʰɛn̪ˠt̪/" },
  { word: "a' peantadh", ipa: "/ˈpʰɛn̪ˠt̪əɣ/" },
  { word: "dealbhadair", ipa: "/ˈtʲal̪ˠavətɛɾʲ/" },
  { word: "air leth", ipa: "no ipa found" },
  { word: "bruis", ipa: "/pɾuʃ/" },
  { word: "dath", ipa: "/tah/" },
  { word: "dathan", ipa: "/dah/" },
  { word: "sgrìobhadair", ipa: "/ˈs̪kɾiːvətɛɾʲ/" },
  { word: "tìde", ipa: "/ˈt͡ʃʰiːtʲə/" },
  { word: "fad", ipa: "/fad/" },
  { word: "ùghdar", ipa: "/uːdər/" },
  { word: "leabhraichean", ipa: "no ipa found" },
  { word: "cleasaiche", ipa: "/ˈkʰles̪ɪçə/" },
  { word: "rùisgte", ipa: "/ˈrˠuːʃtʲə/" },
  { word: "àrd-ùrlar", ipa: "/aːRd uːRLər/" },
  { word: "talla-cluiche", ipa: "no ipa found" },
  { word: "pinnt", ipa: "/pʰĩːɲtʲ/" },
  { word: "a' rànaich", ipa: "/ˈrˠaːnɪç/" },
  { word: "dealbh-chluich", ipa: "/ˈtʲal̪ˠavxl̪ˠɪç/" },
  { word: "tric", ipa: "/t̪ɾiçkʲ/" },
  { word: "dràma", ipa: "/ˈt̪ɾaːmə/" },
  { word: "talla", ipa: "/ˈtʰal̪ˠə/" },
  { word: "a' gàireachdainn", ipa: "/ˈkaːɾʲəxkɪɲ/" },
  { word: "seinneadair", ipa: "/ˈʃeɲət̪ɪɾʲ/" },
  { word: "mòine", ipa: "/ˈmɔːɲə/" },
  { word: "cruthachail", ipa: "/ˈkʰɾuhəxal/" },
  { word: "film", ipa: "/ˈfilim/" },
  { word: "dìosal", ipa: "/ˈtʲiːs̪əl̪ˠ/" },
  { word: "dannsair", ipa: "/ˈtãũn̪ˠs̪ɛɾʲ/" },
  { word: "sgrìobhadh", ipa: "/ˈs̪kɾʲiːvəɣ/" },
  { word: "nas òige", ipa: "no ipa found" },
  { word: "nas sine", ipa: "no ipa found" },
  { word: "nas brònaiche", ipa: "no ipa found" },
  { word: "peadar", ipa: "/pedər/" },
  { word: "nas luaithe", ipa: "no ipa found" },
  { word: "nas blàithe", ipa: "no ipa found" },
  { word: "madainn", ipa: "/ˈmat̪ˠɪɲ/" },
  { word: "nas slaodaiche", ipa: "no ipa found" },
  { word: "nas fhuaire", ipa: "no ipa found" },
  { word: "nas aotruime", ipa: "no ipa found" },
  { word: "nas truime", ipa: "no ipa found" },
  { word: "riutha", ipa: "/ˈɾʲu.ə/" },
  { word: "ailbhean", ipa: "/ˈɛl̪ɛvan/" },
  { word: "draibh", ipa: "/t̪ɾaiv/" },
  { word: "rinn", ipa: "/rˠiːɲ/" },
  { word: "nas glice", ipa: "no ipa found" },
  { word: "mar-thà", ipa: "/mərˈhaː/" },
  { word: "nas gòraiche", ipa: "no ipa found" },
  { word: "coiseachd", ipa: "/ˈkʰɔʃəxk/" },
  { word: "fiaclairean", ipa: "/fiəxgLɛrʲ/" },
  { word: "saighdearan", ipa: "/sɤidʲər/" },
  { word: "saighdear", ipa: "/ˈsɤitʲəɾ/" },
  { word: "fiaclair", ipa: "/fiəxgLɛrʲ/" },
  { word: "bheataichean", ipa: "no ipa found" },
  { word: "oileanach", ipa: "/ɤlanəx/" },
  { word: "bheat", ipa: "no ipa found" },
  { word: "oileanaich", ipa: "/ɤlanəx/" },
  { word: "gasta", ipa: "/gasdə/" },
  { word: "luchd-smàlaidh", ipa: "no ipa found" },
  { word: "luchd-lagha", ipa: "no ipa found" },
  { word: "luchd-saidheans", ipa: "no ipa found" },
  { word: "neach-saidheans", ipa: "no ipa found" },
  { word: "neach-lagha", ipa: "no ipa found" },
  { word: "amadan", ipa: "/ˈamat̪an/" },
  { word: "òinseach", ipa: "/ɔːNʲʃəx/" },
  { word: "breugach", ipa: "/brʲiagəx/" },
  { word: "cheannaich", ipa: "/ˈçan̪ˠɪç/" },
  { word: "chuir", ipa: "/kurʲ/" },
  { word: "loidhne", ipa: "/ˈl̪ˠɔinə/" },
  { word: "notaichean", ipa: "/Nɔhd/" },
  { word: "sgeilp", ipa: "/s̪kʲelp/" },
  { word: "giotàr", ipa: "/kʲɪˈt̪ʰaːɾ/" },
  { word: "reic", ipa: "/rˠeçkʲ/" },
  { word: "a' reic", ipa: "/rˠeçkʲ/" },
  { word: "sgillinnean", ipa: "/sgʲiLʲɪNʲ/" },
  { word: "bàta-luath", ipa: "no ipa found" },
  { word: "beartach", ipa: "/ˈpjarˠʃtəx/" },
  { word: "ghoid", ipa: "/ɣɤtʲ/" },
  { word: "bhruidhinn", ipa: "/ˈvɾi.ɪɲ/" },
  { word: "teanta", ipa: "no ipa found" },
  { word: "sporan", ipa: "/ˈspɔran/" },
  { word: "cha do", ipa: "no ipa found" },
  { word: "lorg", ipa: "/ˈɫ̪ɔrɔk/" },
  { word: "bruis-fhiaclan", ipa: "/pɾuʃ ˈiəxkl̪ˠən/" },
  { word: "fòn", ipa: "/foːn/" },
  { word: "neach-reic", ipa: "no ipa found" },
  { word: "an-asgaidh", ipa: "/əˈn̪ˠaskɪ/" },
  { word: "a' lorg", ipa: "/ˈɫ̪ɔrɔk/" },
  { word: "sreap", ipa: "/strɛhp/" },
  { word: "beathach", ipa: "/ˈpɛhəx/" },
  { word: "beathaichean", ipa: "/ˈpɛhɪçən/" },
  { word: "fiadhaich", ipa: "/ˈfiə.ɪç/" },
  { word: "damh", ipa: "/tav/" },
  { word: "madadh-allaidh", ipa: "/madəˈɣaLɪ/" },
  { word: "a' tuiteam", ipa: "/ˈtʰuhtʲəm/" },
  { word: "a' sealg", ipa: "/ˈʃaɫ̪ak/" },
  { word: "madaidhean-allaidh", ipa: "/ˌmat̪ɪjən ˈal̪ˠɪ/" },
  { word: "shreap", ipa: "/hrɛhp/" },
  { word: "toll", ipa: "/tʰɔul̪ˠ/" },
  { word: "a' campadh", ipa: "/ˈkʰãũmpəɣ/" },
  { word: "a' cladhach", ipa: "/ˈkʰl̪ˠɤ.əx/" },
  { word: "thuit", ipa: "/huhtʲ/" },
  { word: "calman", ipa: "/kʰaɫ̪aman/" },
  { word: "nas àirde", ipa: "no ipa found" },
  { word: "nas bòidhche", ipa: "no ipa found" },
  { word: "nas reamhra", ipa: "no ipa found" },
  { word: "nas caoile", ipa: "no ipa found" },
  { word: "cumanta", ipa: "/ˈkʰumən̪ˠt̪ə/" },
  { word: "bailtean", ipa: "/balə/" },
  { word: "cailleannach", ipa: "/kaLʲaNəx/" },
  { word: "lus", ipa: "/l̪ˠus̪/" },
  { word: "lusan", ipa: "/Lus/" },
  { word: "capall-coille", ipa: "/ˌkʰahpəl̪ˠˈkʰɤʎə/" },
  { word: "seunta", ipa: "/ˈʃiən̪ˠt̪ə/" },
];
